






















































































import { mixins } from 'vue-class-component';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CentralViewCard from '@/CentralViewCard.vue';
import BoxViewWrapperObject from '@/BoxViewWrapperObject.vue';
import BarPlotWrapperObject from '@/BarPlotWrapperObject.vue';
import HumidityPlotWrapperObject from '@/HumidityPlotWrapperObject.vue';
import FoodSafetyAndCarbonFootprintCard from '@/FoodSafetyAndCarbonFootprintCard.vue';

@Component({
  components: {
    BoxViewWrapperObject,
    BarPlotWrapperObject,
    HumidityPlotWrapperObject,
    FoodSafetyAndCarbonFootprintCard,
  }
})
export default class GraphsCard extends CentralViewCard {
  name = 'GraphsCard';

  created() {
    this.name = 'GraphsCard';
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GraphsCard.vue